import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=8e2cb3d0&"
import script from "./Detail.vue?vue&type=script&lang=js&"
export * from "./Detail.vue?vue&type=script&lang=js&"
import style0 from "./Detail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jasonliuhan/Documents/project/jcfy-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8e2cb3d0')) {
      api.createRecord('8e2cb3d0', component.options)
    } else {
      api.reload('8e2cb3d0', component.options)
    }
    module.hot.accept("./Detail.vue?vue&type=template&id=8e2cb3d0&", function () {
      api.rerender('8e2cb3d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/container/Detail.vue"
export default component.exports